import { getEnv } from './env';
import { generateUuid } from './uuid';

export const CORRELATION_HEADER = 'x-correlation-id';

const MAX_TRACKED = 20;

interface TrackedCorrelation {
  key: string;
  id: string;
}

const recent: TrackedCorrelation[] = [];

export const isCorrelationHeaderEnabled = (): boolean => getEnv().VITE_SEND_CORRELATION_ID === 'true';

export const createCorrelationId = (): string => `CID-${generateUuid()}`;

const toKey = (method: string | undefined, url: string | undefined): string =>
  `${(method ?? 'get').toUpperCase()} ${url ?? ''}`;

export const rememberCorrelationId = (method: string | undefined, url: string | undefined, id: string): void => {
  recent.unshift({ key: toKey(method, url), id });
  recent.length = Math.min(recent.length, MAX_TRACKED);
};

export const getLastCorrelationId = (urlFragment: string): string | undefined =>
  recent.find(({ key }) => key.includes(urlFragment))?.id;

export const clearTrackedCorrelationIds = (): void => {
  recent.length = 0;
};

interface HeaderBag {
  get?: (name: string) => unknown;
  [key: string]: unknown;
}

export const readCorrelationId = (headers: unknown): string | undefined => {
  if (!headers || typeof headers !== 'object') return undefined;
  const bag = headers as HeaderBag;
  const value = typeof bag.get === 'function' ? bag.get(CORRELATION_HEADER) : bag[CORRELATION_HEADER];
  return typeof value === 'string' && value.length > 0 ? value : undefined;
};
